import {inject, Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {GarageService} from '@ox/data';
import {isEmpty} from 'lodash';
import {interval, takeWhile} from 'rxjs';

@Injectable()
export class GarageRedirect {
    private router = inject(Router);
    private garageService = inject(GarageService);

    canActivate() {
        return new Promise<boolean>(resolve => {
            let gbpe = window.gbpe;
            interval(100).pipe(takeWhile(() => !gbpe))
                .subscribe({
                    next: () => {
                        gbpe = window.gbpe;
                    },
                    complete: async () => {
                        try {
                            await gbpe.auth.loaded;
                            if (!gbpe.auth.currentAuthState && gbpe.auth.currentAuthState === 0) return resolve(true);
                            if (!gbpe.user) return resolve(true);
                            const {data: {garage}} = await gbpe.user.vehicles;
                            if (!garage || Array.isArray(garage) && isEmpty(garage)) {
                                this.router.navigate(['../garage']);
                            }
                        } catch (e) {
                            console.error(e);
                        }
                        resolve(true);
                    }
                });
        });
    }
}
